import { useEffect } from "react";
import { useObservatoryAudio } from "../experience/useObservatoryAudio";
import { useNexusStore } from "../store/nexusStore";

const IDLE_DELAY_MS = 12_000;

export function ExperienceDirector() {
  const setIdleMode = useNexusStore((state) => state.setIdleMode);
  const toggleEasterEgg = useNexusStore((state) => state.toggleEasterEgg);
  useObservatoryAudio();

  useEffect(() => {
    let idle = false;
    let lastActivity = performance.now();
    let timer = 0;
    const checkIdle = () => {
      const remaining = IDLE_DELAY_MS - (performance.now() - lastActivity);
      if (remaining > 0) {
        timer = window.setTimeout(checkIdle, remaining);
        return;
      }
      idle = true;
      setIdleMode(true);
    };
    timer = window.setTimeout(checkIdle, IDLE_DELAY_MS);
    const wake = () => {
      lastActivity = performance.now();
      if (!idle) return;
      idle = false;
      setIdleMode(false);
      window.clearTimeout(timer);
      timer = window.setTimeout(checkIdle, IDLE_DELAY_MS);
    };
    const events: Array<keyof WindowEventMap> = ["pointermove", "pointerdown", "keydown", "wheel", "touchstart"];
    for (const event of events) window.addEventListener(event, wake, { passive: true });
    return () => {
      window.clearTimeout(timer);
      for (const event of events) window.removeEventListener(event, wake);
    };
  }, [setIdleMode]);

  useEffect(() => {
    let sequence = "";
    const handler = (event: KeyboardEvent) => {
      if (event.metaKey || event.ctrlKey || event.altKey) return;
      sequence = `${sequence}${event.key.toLowerCase()}`.slice(-12);
      if (sequence.endsWith("eventhorizon")) {
        toggleEasterEgg();
        sequence = "";
      }
    };
    window.addEventListener("keydown", handler);
    return () => window.removeEventListener("keydown", handler);
  }, [toggleEasterEgg]);

  return null;
}
